import { faker } from '@faker-js/faker';

import type { IDN } from '~/api/types';

import { AddressFactory } from './address';
import { sanitizeCompanyName } from '../../utils';

type IDNFactoryParams = Partial<IDN>;

// In the real API usersWithoutDepartment users without department but assigned to a specific IDN will be handled differently. For now, we just use a plain array in the IDN.
export type MSWIDN = IDN & { usersWithoutDepartment: string[] };

export const IDNFactory = (override: IDNFactoryParams): MSWIDN =>
  ({
    id: faker.string.numeric(6),
    name: sanitizeCompanyName(),
    address: AddressFactory(),
    phone: faker.phone.number({ style: 'international' }),
    usersWithoutDepartment: [],
    ...override,
  }) satisfies MSWIDN;
